import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { StatesAndProvinces, useProductCenterApi } from 'api';
import { getStatesAndProvincesQuery } from 'api/queries';
import { isStatesAndProvinces } from 'api/responses/models/Configuration/StatesAndProvincesDto';

export interface LocationStateTextProps {
	state?: string | null;
	countryCodeWithStatesAndProvinces: StatesAndProvinces;
}

export const LocationStateText = ({
	state,
	countryCodeWithStatesAndProvinces,
}: LocationStateTextProps): React.JSX.Element => {
	const { api } = useProductCenterApi();
	const { data } = useQuery({
		...getStatesAndProvincesQuery(api, countryCodeWithStatesAndProvinces),
		enabled:
			!!state && isStatesAndProvinces(countryCodeWithStatesAndProvinces),
	});

	const stateName = useMemo(
		() =>
			data?.find(({ abbreviation }) => abbreviation === state)?.name ||
			state ||
			'',
		[data, state]
	);

	return <>{stateName}</>;
};
